import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { apiConstant } from '../app.constant';
import { Integrations, Integration } from '../app.model';

@Injectable({
  providedIn: 'root'
})
export class IntegrationsService {

  constructor(private http: HttpClient) { }

  getInegrations() {
    let apiUrl = `${environment.baseUrl}` + apiConstant.INTEGRATIONS;
    return this.http.get<Integrations>(apiUrl);
  }

  getIntegration(integrationUuid: string) {
    let apiUrl = `${environment.baseUrl}` + apiConstant.INTEGRATIONS + '/' + integrationUuid;
    return this.http.get<Integration>(apiUrl);
  }

  updateIntegrationSettings(integrationUuid: string, settings: any) {
    let apiUrl = `${environment.baseUrl}` + apiConstant.INTEGRATIONS + '/' + integrationUuid;
    return this.http.put(apiUrl, { settings });
  }

}
